import Swiper from 'swiper';

export default () => {
	const data = {
		swiperObject: new Swiper('.home-swiper', {
			loop: true,
			init: false,
		}),
		nextImage: '',
		nextText: '',
		isFilling: true,
		switchJob: 0,
		numberOfSlides: 0,
		updateNext() {
			const nextIndex =
				this.swiperObject.activeIndex % this.numberOfSlides;
			this.nextImage = document.querySelector(
				`.home-swiper > .swiper-wrapper > [data-swiper-slide-index="${nextIndex}"] img`
			).src;
			this.nextText = document.querySelector(
				`.home-swiper > .swiper-wrapper > [data-swiper-slide-index="${nextIndex}"] h1`
			).innerText;
		},
		stopSwitching() {
			clearInterval(this.switchJob);
			this.isFilling = false;
		},
		restartSwitching() {
			this.stopSwitching();
			this.$nextTick(() => {
				this.isFilling = true;
			});
			this.switchJob = setInterval(
				() => this.swiperObject.slideNext(),
				7000
			);
		},
		setNumberOfSlides() {
			this.numberOfSlides = document.querySelectorAll(
				'.home-swiper > .swiper-wrapper > .swiper-slide'
			).length;
		},
		mainProps: {
			['@updatenext.window']() {
				this.updateNext();
				this.restartSwitching();
			},
		},
		pointerProps: {
			['@pointerenter']() {
				this.stopSwitching();
			},
			['@pointerleave']() {
				this.restartSwitching();
			},
		},
	};
	const dispatchUpdateEvent = () => {
		const e = new CustomEvent('updatenext', {});
		window.dispatchEvent(e);
	};

	data.switchJob = setInterval(() => data.swiperObject.slideNext(), 7000);
	data.swiperObject.on('slideChangeTransitionStart', dispatchUpdateEvent);
	data.swiperObject.on('beforeInit', data.setNumberOfSlides.bind(data));

	data.swiperObject.init();
	data.updateNext();

	return data;
};
